export default function Textcontainer({text}){
    return (
        <div>
            <p>{text}</p>
        </div>
    )
}